export const MenuItems = [
  {
    title: "Home",
    pageName: "home",
    url: "/",
    cName: "nav-Links",
  },
  {
    title: "Account Manager",
    pageName: "account-manager",
    url: "/acctmgr",
    cName: "nav-Links",
  },
  {
    title: "AT&T Cisco NBD",
    pageName: "att-cnbd",
    url: "/att-cnbd",
    cName: "nav-Links",
  },
  {
    title: "Login/Profile",
    pageName: "login",
    url: "/login",
    cName: "nav-Links-Mobile",
  },
];
